export const model = {
  id: null,
  name: '',
  country_id: '', 
  created_at: '',
  updated_at: '',
};
